// if the module has no dependencies, the above pattern can be simplified to
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define([], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        var pt = factory();

        root.qd.qRules.paramTypes = pt;
        // legacy alias
        root.qd.qRules.controlTypes = pt;
    }
}(typeof self !== 'undefined' ? self : this, function () {
    var paramTypeOption = "dropdown";

    return {
        typeOption: paramTypeOption,
        // DEPRECATED alias for typeOption
        typeDropDown: paramTypeOption,
        typeBoolean: "boolean",
        typeNumber: "number",
        typeDataSource: "datasource",
        typeDataConnection: "dataconnection",
        typeXPath: "xpath"
    };
}));